import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'

import auth from '@/middleware/auth'
import guest from '@/middleware/guest'
import open from '@/middleware/open'

import store from '@/store'

const user = localStorage.getItem('user')

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        middleware: auth
      }
    },
    {
      path: '/awards',
      name: 'awards.index',
      meta: {
        title: 'Awards',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "awardsIndex" */ '../views/awards/Index.vue')
    },
    {
      path: '/awards/create',
      name: 'awards.create',
      meta: {
        title: 'Add Award',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "awardsCreate" */ '../views/awards/Create.vue')
    },
    {
      path: '/awards/:id/edit',
      name: 'awards.edit',
      meta: {
        title: 'Edit Award',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "awardsEdit" */ '../views/awards/Edit.vue')
    },
    {
      path: '/laureates',
      name: 'laureates.index',
      meta: {
        title: 'Laureates',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "laureates" */ '../views/laureates/Index.vue')
    },
    {
      path: '/laureates/create',
      name: 'laureates.create',
      meta: {
        title: 'Add Laureate',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "laureatesCreate" */ '../views/laureates/Create.vue')
    },
    {
      path: '/laureates/:id/edit',
      name: 'laureates.edit',
      meta: {
        title: 'Edit Laureate',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "laureatesEdit" */ '../views/laureates/Edit.vue')
    },
    {
      path: '/users',
      name: 'users.index',
      meta: {
        title: 'Users',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "users" */ '../views/users/Index.vue')
    },
    {
      path: '/users/create',
      name: 'users.create',
      meta: {
        title: 'Send Invite',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "usersCreate" */ '../views/users/Create.vue')
    },
    {
      path: '/users/:id/edit',
      name: 'users.edit',
      meta: {
        title: 'Edit User',
        middleware: auth
      },
      component: () => import(/* webpackChunkName: "usersEdit" */ '../views/users/Edit.vue')
    },

    // Auth
    {
      path: '/login',
      name: 'auth.login',
      meta: {
        middleware: guest
      },
      component: () => import(/* webpackChunkName: "authLogin" */ '../views/auth/Login.vue')
    },
    {
      path: '/register/:token/:awardId?',
      name: 'auth.register',
      meta: {
        middleware: open
      },
      component: () => import(/* webpackChunkName: "authRegister" */ '../views/auth/Register.vue')
    },
    {
      path: '/forgot-password',
      name: 'auth.forgotPassword',
      meta: {
        middleware: guest
      },
      component: () => import(/* webpackChunkName: "authForgotPassword" */ '../views/auth/ForgotPassword.vue')
    },
    {
      path: '/reset-password/:token',
      name: 'auth.resetPassword',
      meta: {
        middleware: guest
      },
      component: () => import(/* webpackChunkName: "authResetPassword" */ '../views/auth/ResetPassword.vue')
    }
  ]
})

// We have to implement a Middleware to allow user to access certain routes
// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory (context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters)
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  const middleware = Array.isArray(to.meta.middleware)
    ? to.meta.middleware
    : [to.meta.middleware]

  const context = {
    from,
    next,
    store,
    router,
    to
  }

  const nextMiddleware = nextFactory(context, middleware, 1)

  return middleware[0]({ ...context, next: nextMiddleware })
})

router.afterEach((to, from) => {
  if ((!store.getters.isAuthenticated && !user) || to.name === 'auth.register') {
    store.commit('SET_LAYOUT', 'auth-layout')
  } else {
    store.commit('SET_LAYOUT', 'app-layout')
  }
})

export default router
